import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

export const DEMO_RESET_URL = '/api/dev/demo/reset';

@Injectable()
export class DemoReset {
  private readonly http = inject(HttpClient);

  public reset(): Promise<void> {
    return firstValueFrom(this.http.post<void>(DEMO_RESET_URL, undefined));
  }
}
